import moment from "moment";
import { AnyDate, AnyTime, TimeOnly } from "typings/DateTime";
import { HOURS_24_VALUE } from "Utils/date";

export const timeToDuration = (time: TimeOnly, unitOfDuraition: moment.unitOfTime.Base): number => {
    return moment.duration(time).as(unitOfDuraition);
}
